<template>

<main class="py-12 space-y-12">
        <section>
          <div class="container lg:columns-2 gap-16">
                <h1>Mit vollem Tempo voraus!</h1>
                <p class="article-teaser">
                    Damit Ihre Kinder ein tolles Erlebnis mit unseren Spielgeräten haben, bieten wir Ihnen diese in bester Qualität.
                </p>
                <p>
                    Alle Metallrutschen sind in feuerverzinkter Ausführung mit V2A-Edelstahlrutschflächen oder komplett aus V2A-Edelstahl erhältlich (Edelstahlgüte 1.4301).
                </p>
            <p>Die Seitenwangen der Metallrutschen sind aus 2,0 mm starken Blechen mit einem aufgeschweißten Handlaufrohr, ø 2,7 cm, gefertigt.
              Zusätzlich werden die Seitenwangen der V2A-Edelstahlrutschen glasperlgestrahlt. Die insgesamt 4 mm starken Rutschflächen sind dreilagig schallgedämmt aufgebaut.
              Unter der 1,5 mm starken V2A-Edelstahl-Rutschfläche ist ein 1 mm starkes, verrottungsfestes Anti-Dröhnvlies angebracht. Unter diesem wird, je nach Ausführung, ein 1,5 mm starkes feuerverzinktes Stahlblech oder ein 1,5 mm starkes V2A-Edelstahlblech eingebaut.</p>
            <p>
                    Die dreilagige Rutschfläche wird mit den Seitenteilen außen vernietet. Bei einer Beschädigung der Rutschfläche ist diese einzeln austauschbar.
                    Eine solche Konstruktionsweise reduziert die Folgekosten, da die Rutsche nicht komplett ersetzt werden muss.
                    Die Leiteraufgänge sind aus verschweißtem Rundrohr. Das Handlaufrohr hat einen Durchmesser von 3,3 cm. Die Trittstufen haben einen Rohrdurchmesser von 2,7 cm.
                </p>
            </div>
        </section>

        <section>
            <Carousel/>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/Material/Rutschen',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Tempo',
};
</script>

<style scoped>

</style>
